import { render, staticRenderFns } from "./ActualizarMonto.vue?vue&type=template&id=6af02589"
import script from "./ActualizarMonto.vue?vue&type=script&lang=ts"
export * from "./ActualizarMonto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports